import React, { Component, PureComponent } from "react";
import * as cel from "d3-celestial";
import DOMPurify from "dompurify";
import "d3-celestial/celestial.css";
import "./editor-map.css";
import i18n from "i18next";

export default class Map extends Component {
  static whyDidYouRender = true;
  isSmallScreen = true;

  constructor(props) {
    super(props);
    this._text1 = this.getFixedText1(props.text1);
    this._poster = React.createRef();
    this._map = React.createRef();
    this.isRendering = false;
  }

  addMw() {
    //var img = document.getElementById("template");
    var img = new Image();
    //https://yoksel.github.io/url-encoder/
    img.src =
      "data:image/svg+xml,%3Csvg height='3' width='3' viewBox='0 0 3 3' xmlns='http://www.w3.org/2000/svg' version='1.1'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23bbb' /%3E%3C/svg%3E";

    cel.Celestial().add({
      file: "/sky/data/mw2.json",
      type: "line",

      callback: function (error, json) {
        if (error) return console.warn(error);
        // Load the geoJSON file and transform to correct coordinate system, if necessary
        var mw = json;

        var Celestial = cel.Celestial();

        //Celestial.getData(jsonLine, config.transform);

        // Add to celestial objects container in d3
        Celestial.container
          .selectAll(".mway")
          .data(mw.features)
          .enter()
          .append("path")
          .attr("class", "mw2");

        // Trigger redraw to display changes
        Celestial.redraw();
      },

      redraw: function () {
        var Celestial = cel.Celestial();

        var mwPattern = Celestial.context.createPattern(img, "repeat");

        var mwStyle = {
          fill: mwPattern,
          // fill: "#bbbbbb",
          opacity: "0.7",
        };

        Celestial.container.selectAll(".mw2").each(function (d) {
          Celestial.setStyle(mwStyle);
          Celestial.map(d);

          //Celestial.context.fillStyle = mwPattern;
          Celestial.context.fill();
        });
      },
    });
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();

    var config = this.getInitialCelestialConfig(this.props, this.isSmallScreen);

    //this.addMw();

    cel.Celestial().display(config);
    this.updateMapPosition(this.props);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    console.log("Calculating window size");
    let width = window.innerWidth;
    let isSmallScreen = width < 768 ? true : false;
    this.isSmallScreen = isSmallScreen;
  };

  getFixedText1(text1) {
    if (text1) {
      try {
        return DOMPurify.sanitize(text1).replace(
          /❤️/g,
          '<i class="fa fa-heart"></i>'
        );
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    }
    return "";
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     prevProps.latitude !== this.props.latitude ||
  //     prevProps.longitude !== this.props.longitude ||
  //     prevProps.date !== this.props.date
  //   ) {
  //     this.updateMap();
  //   }
  //   if (prevProps.map != this.props.map) {
  //     this.updateConfig();
  //   }
  // }

  componentWillReceiveProps(nextProps) {
    this._text1 = this.getFixedText1(nextProps.text1);
    if (
      nextProps.latitude !== this.props.latitude ||
      nextProps.longitude !== this.props.longitude ||
      nextProps.date !== this.props.date
    ) {
      this.updateMapPosition(nextProps);
    }
    if (nextProps.map != this.props.map) {
      let needChangeCanvasSize = false;
      if (nextProps.styleId !== this.props.styleId) {
        var prevDivider = this.getAdditionalDividerByStyleId(
          this.props.styleId
        );
        var nextDivider = this.getAdditionalDividerByStyleId(nextProps.styleId);
        if (prevDivider !== nextDivider) {
          needChangeCanvasSize = true;
        }
      }
      this.updateConfig(nextProps, this.isSmallScreen, needChangeCanvasSize);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.text1 !== this.props.text1 ||
      nextProps.text2 !== this.props.text2 ||
      nextProps.ratio !== this.props.ratio ||
      nextProps.styleId !== this.props.styleId
    ) {
      console.log("map should update!");
      return true;
    } else {
      console.log("map shouldn't update");
      return false;
    }
  }

  getAdditionalDividerByStyleId(styleId) {
    if (styleId && styleId.indexOf("_clip_heart") > 0) {
      return 1.5;
    } else {
      return 1;
    }
  }

  getInitialCelestialConfig(props, isSmallScreen) {
    let sizeDivider = 1;
    if (isSmallScreen) {
      sizeDivider = 2;
    }

    if (props) {
      sizeDivider =
        sizeDivider / this.getAdditionalDividerByStyleId(props.styleId);
    }

    var lang = i18n.language;

    var isNamesEnabled = props.map.features.find(
      (f) => f.id == "isNamesEnabled"
    );
    var config = {
      width: 500 / sizeDivider,
      projection: "stereographic",
      adaptable: false, // Sizes are increased with higher zoom-levels
      interactive: false, // Enable zooming and rotation with mousewheel and dragging
      form: false,
      controls: false, // Display zoom controls
      lang: "", // Global language override for names, any name setting that has the chosen language available
      // Default: desig or empty string for designations, other languages as used anywhere else
      culture: "", // Source of constellations and star names, default "iau", other: "cn" Traditional Chinese
      container: "celestial-map", // ID of parent element, e.g. div, null = html-body
      datapath: "/sky/data/", // Path/URL to data files, empty = subfolder 'data'
      stars: {
        show: true, // Show stars
        limit: 6, // Show only stars brighter than limit magnitude
        colors: false, // Show stars in spectral colors, if not use default color
        style: { fill: "#ffffff", opacity: 1 }, // Default style for stars
        designation: false, // Show star names (Bayer, Flamsteed, Variable star, Gliese or designation,
        size: 5 / sizeDivider, // Maximum size (radius) of star circle in pixels,
      },
      dsos: {
        show: false,
      },
      planets: {
        show: false,
      },
      constellations: {
        names: isNamesEnabled ? isNamesEnabled.isEnabled : false, // Show constellation names
        namesType: lang, // What kind of name to show (default 3 letter designations) all options: name, desig,
        // lat, en, ar, cn, cz, ee, fi, fr, de, gr, il, it, jp, kr, in, ir, ru, es, tr
        nameStyle: {
          fill: "#ffffff",
          align: "center",
          baseline: "middle",
          width: [0.5 / sizeDivider, 0.5 / sizeDivider, 0.5 / sizeDivider],
          stroke: [
            props.map.background,
            props.map.background,
            props.map.background,
          ],
          opacity: 1,
          font: [
            "400 " +
              (2.26 * 5) / sizeDivider +
              "px 'Caveat', Arial, sans-serif", // Style for constellations
            "400 " +
              (2.03 * 5) / sizeDivider +
              "px 'Caveat', Arial, sans-serif", // Different fonts for diff.
            "400 " +
              (1.69 * 5) / sizeDivider +
              "px 'Caveat', Arial, sans-serif",
          ], // ranked constellations
        },
        lines: props.map.features.find((f) => f.id == "isConstellationsEnabled")
          .isEnabled,
        lineStyle: {
          stroke: "#dddddd",
          width: 1.5 / sizeDivider,
          opacity: 0.7,
        },
      },
      mw: {
        show: props.map.features.find((f) => f.id == "isMWEnabled").isEnabled, // Show Milky Way as filled multi-polygon outlines
        // style: { fill: "#ffffff", opacity: 0.15 }  // Style for MW layers
      },
      lines: {
        // Display & styles for graticule & some planes
        graticule: {
          show: props.map.features.find((f) => f.id == "isGridEnabled")
            .isEnabled,
          stroke: "#cccccc",
          width: 0.5 / sizeDivider,
          opacity: 0.8,
        },
        equatorial: {
          show: false,
        },
        ecliptic: {
          show: false,
        },
        galactic: {
          show: false,
        },
        supergalactic: {
          show: false,
        },
      },
      background: {
        fill: props.map.background,
        opacity: 1,
        stroke: props.map.stroke,
        width: 5 / sizeDivider,
      },
      horizon: {
        //Show horizon marker, if location is set and map projection is all-sky
        show: false,
      },
      daylight: {
        //Show day sky as a gradient, if location is set and map projection is hemispheric
        show: false,
      },
    };

    return config;
  }

  getUpdatedCelestialConfig(props, isSmallScreen) {
    let sizeDivider = 1;
    if (isSmallScreen) {
      sizeDivider = 2;
    }

    var isNamesEnabled = props.map.features.find(
      (f) => f.id == "isNamesEnabled"
    );
    var config = {
      constellations: {
        names: isNamesEnabled ? isNamesEnabled.isEnabled : false, // Show constellation names

        lines: props.map.features.find((f) => f.id == "isConstellationsEnabled")
          .isEnabled, // Show constellation lines, style below
      },
      mw: {
        show: props.map.features.find((f) => f.id == "isMWEnabled").isEnabled,
      },
      lines: {
        graticule: {
          show: props.map.features.find((f) => f.id == "isGridEnabled")
            .isEnabled,
          stroke: "#cccccc",
          width: 0.5 / sizeDivider,
          opacity: 0.8,
        },
      },
      background: {
        fill: props.map.background, // Area fill
        stroke: props.map.stroke, // Outline
      },
    };

    return config;
  }

  updateConfig = (props, isSmallScreen, needChangeCanvasSize) => {
    console.log("Updating celestial config");

    if (needChangeCanvasSize) {
      var config = this.getInitialCelestialConfig(props, isSmallScreen);
      //Если менять размер канваса до того, как закончится анимация вращения, то размер применяется неправильно
      this.redrawCelestialWhenRenderIsComplete(config);
    } else {
      var config = this.getUpdatedCelestialConfig(props, isSmallScreen);
      cel.Celestial().apply(config);
    }
  };

  redrawCelestialWhenRenderIsComplete = (config) => {
    if (this.isRendering) {
      console.log("Waiting till render is complete");
      window.setTimeout(this.redrawCelestialWhenRenderIsComplete, 1000, config);
    } else {
      console.log("Render is complete");
      cel.Celestial().display(config);
    }
  };

  updateMapPosition = (props) => {
    console.log("Updating celestial position");

    this.isRendering = true;
    let that = this;
    setTimeout(() => {
      that.isRendering = false;
    }, 10000);
    cel.Celestial().skyview({
      date: props.date,
      location: [props.latitude, props.longitude],
    });
  };

  getMapSize = () => {
    //const { width, height } = cel.Celestial().metrics();

    return {
      width: this._map.current.firstChild.offsetWidth,
      height: this._map.current.firstChild.offsetHeight,
      containerWidth: this._poster.current.offsetWidth,
      containerHeight: this._poster.current.offsetHeight,
    };
  };

  render() {
    let renderOverlay = (styleId) => {
      if (styleId && styleId === "simple_white_overlay_couple") {
        return (
          <div
            class="position-absolute"
            style={{ bottom: "0.5%", width: "100%" }}
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/img/couple.png"}
              class="img-fluid"
              style={{ width: "30%" }}
            />
          </div>
        );
      }
      return null;
    };
    console.log("Rendering editor-map");
    return (
      <div class={"poster-wrapper" + " ratio-" + this.props.ratio}>
        <div
          class={"u-shadow-v1-5 poster " + this.props.styleId}
          ref={this._poster}
        >
          <div class="poster-inner-border">
            <div class="poster-inner d-flex flex-column  ">
              {/* загрузка шрифта */}
              <div
                style={{
                  height: 0,
                  width: 0,
                  overflow: "hidden",
                }}
              >
                <span style={{ fontFamily: "Caveat", fontSize: "0px" }}>
                  font завантаження...
                </span>
              </div>
              {/* <svg class="clip-svg" width="0" height="0">
                <defs>
                  <clipPath id="heart" clipPathUnits="objectBoundingBox">
                    <path d="M1,0.385 c0,-0.168,-0.117,-0.304,-0.262,-0.304 a0.262,0.304,0,0,0,-0.238,0.179 A0.262,0.304,0,0,0,0.263,0.081 C0.118,0.081,0.001,0.218,0.001,0.385 a0.262,0.304,0,0,0,0.093,0.232 L0.493,1 a0.012,0.015,0,0,0,0.009,0.004 a0.013,0.015,0,0,0,0.009,-0.004 L0.924,0.6 l0,0 a0.26,0.302,0,0,0,0.077,-0.214" />
                  </clipPath>
                </defs>
              </svg> */}

              <div
                class="map-container position-relative"
                style={{ overflow: "hidden" }}
              >
                <div
                  id="celestial-map"
                  class={
                    "celestial-map " +
                    (this.props.styleId &&
                    this.props.styleId.indexOf("_clip_heart") > 0
                      ? "celestial-map-square"
                      : "")
                  }
                  ref={this._map}
                ></div>

                <div
                  class={
                    " " +
                    (this.props.styleId &&
                    this.props.styleId.indexOf("_clip") > 0
                      ? "clip clip-" + this.props.styleId
                      : "d-none ")
                  }
                ></div>

                {renderOverlay(this.props.styleId)}
              </div>
              <div class="flex-grow-1 d-flex justify-content-center flex-column">
                <div class="poster-text1 ">
                  <p dangerouslySetInnerHTML={{ __html: this._text1 }}></p>
                </div>
              </div>
              <div class="poster-text2">
                <p>{this.props.text2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
